import AccentPanel from './hh-accent-panel.vue'
import AccordionGroup from './hh-accordion-group.vue'
import AccordionItem from './hh-accordion-item.vue'
import Confidence from './hh-confidence.vue'
import DataItem from './hh-data-item.vue'
import DataList from './hh-data-list.vue'
import ErrorDisplay from './hh-error-display.vue'
import IconButton from './hh-icon-btn.vue'
import InfoAttachment from './hh-info-attachment.vue'
import MessageDisplay from './hh-msg-display.vue'
import TabGroup from './hh-tab-group.vue'
import TabPanel from './hh-tab-panel.vue'
import ToolTip from './hh-tooltip.vue'
import Waiting from './hh-waiting.vue'

import './forms'

import Vue from 'vue'

Vue.component('hh-accent-panel', AccentPanel)
Vue.component('hh-accordion-group', AccordionGroup)
Vue.component('hh-accordion-item', AccordionItem)
Vue.component('hh-confidence', Confidence)
Vue.component('hh-data-item', DataItem)
Vue.component('hh-data-list', DataList)
Vue.component('hh-msg-display', MessageDisplay)
Vue.component('hh-error-display', ErrorDisplay)
Vue.component('hh-icon-btn', IconButton)
Vue.component('hh-info-attachment', InfoAttachment)
Vue.component('hh-tab-group', TabGroup)
Vue.component('hh-tab-panel', TabPanel)
Vue.component('hh-tooltip', ToolTip)
Vue.component('hh-waiting', Waiting)
